 
import { CountryModel, VerificationIdTypeEnum } from "../generated/api";
import { NavigationLink } from "../models/NavigationLink";
import { pageRouteUrls } from "./pageRouteUrls";


 
export const UserProfileLocalStorage = "UserProfileLocalStorage";
export const accessTokenLocalStorage = "AccessToken";
export const SignedOutSessionStorage = "SignedOutSessionStorage";
// Plain (unencrypted) marker set alongside login/logout — used to tell a genuine
// "signed out" state apart from a transient failure to decrypt react-secure-storage
// (its AES key is derived from a browser fingerprint that can vary between page
// loads, e.g. canvas fingerprint noise from privacy extensions), which otherwise
// makes isAuthorized() intermittently report "not authorized" for an active session.
export const SessionActiveLocalStorage = "mtu.sessionActive";

export const SignedOutRequestStatus = "SignedOut";

export const DateFormat = 'MM/dd/yyyy';
export const MediamDateFormat = 'MMM dd, yyyy';
export const TimeFormat = 'hh:mm aa'; 
export const MediamDateTimeFormat = 'MMM dd, yyyy hh:mm aa';
 
export const EmptyToken='00000000-0000-0000-0000-000000000000';

export const UrlExpValidator =/^(https?:\/\/)([\w-]+(\.[\w-]+)+)(:\d+)?(\/[^\s]*)?$/i;
export const EmailExpValidator = /^[A-Z0-9._%+-]+@[A-Z0-9]([A-Z0-9.-]*[A-Z0-9])*\.[A-Z]{2,}$/i; 
export const namesExpValidationExp= /^[A-Za-zÀ-ÖØ-öø-ÿ0-9\.\-\'\s@.]+$/;
export const addressExpValidationExp=/^[A-Za-zÀ-ÖØ-öø-ÿ0-9\.\-\'\s\#\@\%\&\/@.]+$/;
 
export const blockInvalidNumberChar = (e :any) => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault();
export const blockInvalidWholeNumberChar = (e :any) => ['e', 'E', '+', '-', '.', ','].includes(e.key) && e.preventDefault();
export const blockLessGreaterThanChar = (e :any) => ['<', '>'].includes(e.key) && e.preventDefault();

export enum UPDATE_STATUS {
    notstarted = 'Not started.',
    pending = 'In Progress...',
    success = 'Complete!',
    failed = 'Failed.'
  }

   

// -----------------------------
// VerificationIdType shared mapping
// -----------------------------

export type VerificationIdTypeOption = {
    value: VerificationIdTypeEnum;
    label: string;
  };

  
export const VERIFICATION_ID_TYPE_OPTIONS: readonly VerificationIdTypeOption[] =[
    { value: VerificationIdTypeEnum.Passport, label: "Passport" },
    { value: VerificationIdTypeEnum.DL, label: "Driver License" },
    { value: VerificationIdTypeEnum.NationalIDCard, label: "National ID Card" },
    { value: VerificationIdTypeEnum.ResidencePermit, label: "Residence Permit" },
  ] as const;
  
export const VERIFICATION_ID_TYPE_LABEL: Record<
  VerificationIdTypeEnum,
  string
> = VERIFICATION_ID_TYPE_OPTIONS.reduce(
  (acc, opt) => {
    acc[opt.value] = opt.label;
    return acc;
  },
  {} as Record<VerificationIdTypeEnum, string>
);